import { Component, inject, ChangeDetectionStrategy } from '@angular/core'
import { RouteService } from '../../services/route.service'
import { ROUTES } from '../../constants/routes'
import { CompanyListComponent } from './company-list/company-list.component'

@Component({
  selector: 'app-company',
  imports: [CompanyListComponent],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './company.component.html',
})
export class CompanyComponent {
  constructor() {
    const routeService = inject(RouteService)

    const currentRoute = routeService.getUserRoutes(
      ROUTES.COMPANY.title,
      `/admin/${ROUTES.COMPANY.path}`,
    )
    routeService.setRoute(currentRoute)
  }
}
